import { call, takeLatest } from "redux-saga/effects";
import * as portalApis from "../apis/portalApis"
import { PORTAL_CREATE, PORTAL_DELETE, PORTAL_LIST, PORTAL_VIEW, PORTAL_EDIT, USERS_DROPDOWN, ADD_RESOURCE_PORTAL, REMOVE_USER_PORTAL, ADD_USER_PORTAL, GLOSSARY_DROPDOWN, REMOVE_GLOSSARY_PORTAL } from "../actions/types";

export function* portalListWorker(action) {
    try {
        const res = yield call(portalApis.portalsListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* portalViewWorker(action) {
    try {
        const res = yield call(portalApis.portalViewApi, {
            id: action.id,
        });
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* usersDropDownWorker(action) {
    try {
        const res = yield call(portalApis.usersListApi, {});
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* portalCreateWorker(action) {
    try {
        const res = yield call(portalApis.portalCreateApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* portalEditWorker(action) {
    try {
        const res = yield call(portalApis.portalEditApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* portalDeleteWorker(action) {
    try {
        const res = yield call(portalApis.portalDeleteApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* glossaryListPortalWorker(action) {
    try {
        const res = yield call(portalApis.glossaryDropDownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* addResourcePortalWorker(action) {
    try {
        const res = yield call(portalApis.addResourcePortalApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* addUserPortalWorker(action) {
    try {
        const res = yield call(portalApis.addUserPortalApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* removeUserPortalWorker(action) {
    try {
        const res = yield call(portalApis.removeUserPortalApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* removeGlossaryPortalWorker(action) {
    try {
        const res = yield call(portalApis.removeGlossaryPortalApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* portalListWatcher() {
    yield takeLatest(PORTAL_LIST, portalListWorker);
}
export function* portalDeleteWatcher() {
    yield takeLatest(PORTAL_DELETE, portalDeleteWorker);
}

export function* portalViewWatcher() {
    yield takeLatest(PORTAL_VIEW, portalViewWorker);
}

export function* usersDropDownWatcher() {
    yield takeLatest(USERS_DROPDOWN, usersDropDownWorker);
}

export function* portalCreateWatcher() {
    yield takeLatest(PORTAL_CREATE, portalCreateWorker);
}

export function* portalEditWatcher() {
    yield takeLatest(PORTAL_EDIT, portalEditWorker);
}

export function* addResourcePortalWatcher() {
    yield takeLatest(ADD_RESOURCE_PORTAL, addResourcePortalWorker);
}

export function* addUserPortalWatcher() {
    yield takeLatest(ADD_USER_PORTAL, addUserPortalWorker);
}

export function* removeUserPortalWatcher() {
    yield takeLatest(REMOVE_USER_PORTAL, removeUserPortalWorker);
}

export function* glossaryListPortalWatcher() {
    yield takeLatest(GLOSSARY_DROPDOWN, glossaryListPortalWorker);
}

export function* removeGlossaryPortalWatcher() {
    yield takeLatest(REMOVE_GLOSSARY_PORTAL, removeGlossaryPortalWorker);
}